class Footer {
  constructor(wWidth) {
    this.wWidth = wWidth;
    this.$footer = $('.footer');
  }
}

export default Footer;
